import React, { Component } from "react";
import { withGetScreen } from "react-getscreen";
import Dropdown from "../../../../offers/shared/AtomicDropdown";
import { css } from 'emotion';
import Menu from "./Menu";

const dropdownVisible = `
	div {
		position: initial !important;
		display: block !important;
		padding-top: 0 !important;
		padding-bottom: 0 !important;
	}
	ul li{
		margin-bottom: 0 !important;
	}
`;
const dropdownHidden = `
	div {
		display: none;
	}
`;

class MyAccount extends Component {

	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
			headerTitle: ''
		}
	}

	getStatus = (headerTitle = null) => {
		if (headerTitle) {
			this.setState(({ headerTitle: headerTitle }));
		}

		this.setState({ isOpen: !this.state.isOpen });
	}

	render() {
		const { isOpen, headerTitle } = this.state;
		const { isMobile, isTablet } = this.props;

		return (
			<div className="my-account">
				{isMobile() || isTablet() ?
					<Dropdown onClick={() => this.getStatus()} name="menu_small_device" text={headerTitle ? headerTitle : 'Menu'} className={css` ${!isOpen ? dropdownHidden : dropdownVisible}`} >
						<Menu isSmallDevice={isMobile() || isTablet()} onClick={this.getStatus} />
					</Dropdown>
					: <Menu />
				}
			</div>
		);
	}
}

export default withGetScreen(MyAccount, {
	mobileLimit: 582, // TODO Fix screen vars
	tabletLimit: 992, // TODO Fix screen vars
	shouldListenOnResize: true
});
